import * as React from 'react';
import Swoosh from './Swoosh';
import Text from './Text';
import Image from './Image';

const dynamicComponents = {
	text: Text,
	swoosh: Swoosh,
	image: Image,
};

export const DynamicComponent = ({ type, content, ...props }) => {
	let Component = Text;

	if (type === 'divider') {
		if (content !== 'swoosh') {
			return;
		}

		Component = Swoosh;
	} else if (type === 'image') {
		Component = Image;
	}

	// @ts-ignore
	return <Component content={content} {...props} />;
};
